import { ButtonHTMLAttributes } from "react"
import ActionButton from "./action-button"
import { ExportIcon, HelpIcon, PrintIcon } from "Components/atoms/icons"

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

// Standard header/table buttons: same style everywhere, text first and the icon after it.
// (Sync lives in molecule/sync-button because it also shows the last sync time.)

export const ExportButton = (props: ButtonProps) => (
    <ActionButton type="button" {...props}>Export <ExportIcon /></ActionButton>
)

export const PrintButton = (props: ButtonProps) => (
    <ActionButton type="button" {...props}>Print <PrintIcon /></ActionButton>
)

export const HelpButton = (props: ButtonProps) => (
    <ActionButton type="button" {...props}>Help <HelpIcon /></ActionButton>
)
